var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarNumberOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75H4.5C3.25736 3.75 2.25 4.75736 2.25 6V19.5C2.25 20.7426 3.25736 21.75 4.5 21.75H19.5C20.7426 21.75 21.75 20.7426 21.75 19.5V6C21.75 4.75736 20.7426 3.75 19.5 3.75Z",
    stroke: "#282829",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 2.25V3.75M18 2.25V3.75M21.75 7.5H2.25",
    stroke: "#282829",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6991 12.8523L15.1793 11.7614H15.3355V17.4886M8.58478 12.2703C8.73239 12.0208 9.14558 11.625 9.87512 11.625C10.7376 11.625 11.5077 12.0948 11.5077 12.9852C11.5097 13.1576 11.4771 13.3286 11.412 13.4882C11.3468 13.6478 11.2503 13.7928 11.1283 13.9145C10.7557 14.296 10.1871 14.4419 9.87649 14.4419C10.2276 14.4419 10.8716 14.6069 11.293 15.0378C11.563 15.313 11.6877 15.7009 11.6877 16.1311C11.6877 17.0816 10.8856 17.625 9.91092 17.625C9.08694 17.625 8.58137 17.026 8.41501 16.7441",
    stroke: "#282829",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarNumberOutline);
export default __webpack_public_path__ + "static/media/calendar-number-outline.9ba9bdd89e234c45aab8194c21fe7ac9.svg";
export { ForwardRef as ReactComponent };